import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pivot-assist" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setPosition('TopLeft'))),
      class: _normalizeClass(["row-1 col-1", { active: _ctx.position === 'TopLeft' }])
    }, null, 2),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setPosition('TopCenter'))),
      class: _normalizeClass(["row-1 col-2", { active: _ctx.position === 'TopCenter' }])
    }, _hoisted_3, 2),
    _createElementVNode("button", {
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setPosition('TopRight'))),
      class: _normalizeClass(["row-1 col-3", { active: _ctx.position === 'TopRight' }])
    }, _hoisted_5, 2),
    _createElementVNode("button", {
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setPosition('CenterLeft'))),
      class: _normalizeClass(["row-2 col-1", { active: _ctx.position === 'CenterLeft' }])
    }, _hoisted_7, 2),
    _createElementVNode("button", {
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setPosition('Center'))),
      class: _normalizeClass(["row-2 col-2", { active: _ctx.position === 'Center' }])
    }, _hoisted_9, 2),
    _createElementVNode("button", {
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setPosition('CenterRight'))),
      class: _normalizeClass(["row-2 col-3", { active: _ctx.position === 'CenterRight' }])
    }, _hoisted_11, 2),
    _createElementVNode("button", {
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setPosition('BottomLeft'))),
      class: _normalizeClass(["row-3 col-1", { active: _ctx.position === 'BottomLeft' }])
    }, _hoisted_13, 2),
    _createElementVNode("button", {
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setPosition('BottomCenter'))),
      class: _normalizeClass(["row-3 col-2", { active: _ctx.position === 'BottomCenter' }])
    }, _hoisted_15, 2),
    _createElementVNode("button", {
      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.setPosition('BottomRight'))),
      class: _normalizeClass(["row-3 col-3", { active: _ctx.position === 'BottomRight' }])
    }, _hoisted_17, 2)
  ]))
}